import type { SVGProps } from "react";

export function CaretDownIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10L12 14L16 10H8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CaretLeftIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8L10 12L14 16L14 8Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CaretRightIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 16L14 12L10 8L10 16Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function CaretUpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 14L12 10L8 14H16Z"
        fill="currentColor"
      />
    </svg>
  );
}
